import React, {ReactNode, useMemo, useState} from 'react';
import {Box, Container, Logo, Stack, Stripe, Text} from "@mbank-design/design-system/components";
import {BoxBackgroundColor} from "@mbank-design/design-system/enums";
import {MbankCorporate} from "@mbank-design/design-system/logos";
import {LayoutContext} from "./LayoutContext";

interface LayoutProps {
    children? : ReactNode
}

export default function Layout({ children } : LayoutProps) {
    const logoComponent = MbankCorporate;
    const [title, setTitle] = useState('');
    
    const onChangeTitle = (title: string) => {
        setTitle(title);
    }

    const providerValue = useMemo(() => ({
        changeTitle: onChangeTitle
    }), []);
    
    return (
        <Container isFullViewportBackground={true} id={"app_container"}>
            <LayoutContext.Provider value={providerValue}>
                <div className={"app-layout"}>
                    <div className={"stripe"}>
                        <Stripe/>    
                    </div>
                    <div className={"logo-space"}>
                        <Box background={BoxBackgroundColor.MONO_100} height={80}></Box>    
                    </div>
                    <div className={"app-content"}>
                        <Box display={"flex"} justifyContent={"center"} background={BoxBackgroundColor.MONO_200} height={"100%"}>
                            <Stack>
                                <Box display={"flex"} alignItems={"center"} height={80} marginTop={-80} background={BoxBackgroundColor.MONO_100} padding={8}>
                                    <Stack direction="row" alignY="center">
                                        <Logo logoComponent={logoComponent} height={50} />
                                        <Text as={"h4"}>{title}</Text>
                                    </Stack>
                                </Box>
                                <Box background={BoxBackgroundColor.MONO_200} padding={8} height={"100%"}>
                                    {children}
                                </Box>
                            </Stack>
                        </Box>        
                    </div>
                    
                </div>
            </LayoutContext.Provider>
        </Container>
    );
}
